/* tslint:disable */
/* eslint-disable */
export enum WorkWorkflowActionsProjectEnum {
  Created = 'created',
  Planned = 'planned',
  Sale = 'sale'
}
